import { Component, Input } from '@angular/core'
import { Venue } from '../domain/Venue'

@Component({
    selector: 'app-waiting-for-confirmation',
    templateUrl: './waiting-for-confirmation.component.html',
    styleUrls: ['./waiting-for-confirmation.component.sass'],
})
export class WaitingForConfirmationComponent {

    @Input() venue!: Venue
}
